"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchingVehicleIdsFromDealerReducer = void 0;
const matchingVehiclesFromDealer_1 = require("../actions/matchingVehiclesFromDealer");
const initState = [];
const matchingVehicleIdsFromDealerReducer = (vehicleIdsArray = initState, action) => {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case matchingVehiclesFromDealer_1.SET_MATCHING_DEALER_VEHICLE_IDS:
            return [...action === null || action === void 0 ? void 0 : action.payload];
        case matchingVehiclesFromDealer_1.REMOVE_MATCHING_DEALER_VEHICLE_IDS:
            return [];
        default:
            return vehicleIdsArray;
    }
};
exports.matchingVehicleIdsFromDealerReducer = matchingVehicleIdsFromDealerReducer;
//# sourceMappingURL=matchingVehicleIdsFromDealerReducer.js.map